import { typesenseAdapter } from "./typesense-adapter";
import { searchActionHeaders } from "./search-action";
import { handleTypesenseGatewayError } from "./rate-limit";
import { refreshAccessTokenOnce } from "./auth-token-refresh";

export function searchClient(
  query_by,
  inFix,
  token,
  serverType,
  sort_by,
  auth = {}
) {
  const initialAdapter = typesenseAdapter(query_by, inFix, token, serverType, sort_by);
  const baseClient = initialAdapter.searchClient;

  // Wrap the client so that when query is "*" we sort by newest first; otherwise use relevance
  const wrappedClient = {
    ...baseClient,
    async search(requests) {
      try {
        const adjusted = requests.map((req) => {
          const params = req?.params || {};
          const q = params.query ?? params.q;
          // Only inject sort for wildcard searches when no explicit sort is already set
          if (q === "*" && !params.sort_by) {
            return {
              ...req,
              params: { ...params, sort_by: "date:desc" },
            };
          }
          return req;
        });
        const query = adjusted?.[0]?.params?.query ?? adjusted?.[0]?.params?.q ?? "";
        const executeSearch = async (accessToken) => {
          const headers = {
            ...searchActionHeaders(query, serverType === "dictionary" ? "dictionary" : "case_search"),
            ...(accessToken && accessToken !== "noToken"
              ? { Authorization: `Bearer ${accessToken}` }
              : {}),
          };
          const requestClient = typesenseAdapter(
            query_by,
            inFix,
            accessToken,
            serverType,
            sort_by,
            headers
          ).searchClient;
          return requestClient.search(adjusted);
        };

        let accessToken = token;
        if (auth.isAuthenticated && auth.getAccessToken) {
          accessToken = await auth.getAccessToken();
        }

        try {
          return await executeSearch(accessToken);
        } catch (error) {
          const status =
            error?.httpStatus ||
            error?.status ||
            error?.response?.status ||
            error?.response?.statusCode;
          if (
            status !== 401 ||
            !auth.isAuthenticated ||
            !auth.refreshAccessToken ||
            !auth.getAccessToken
          ) {
            throw error;
          }

          await refreshAccessTokenOnce(auth.refreshAccessToken);
          accessToken = await auth.getAccessToken();
          return executeSearch(accessToken);
        }
      } catch (error) {
        throw handleTypesenseGatewayError(error);
      }
    },
  };

  return wrappedClient;
}
